import Vue from "vue";
import Router from "vue-router";
import Menu from "./views/Menu.vue";
import Spider from "./views/Spider.vue";
import Klondike from "./views/Klondike.vue";
import Games from "./views/Games.vue";
import Mines from "./views/Mines.vue"
import RSVP from "./views/RSVP.vue"
import Edit from "./views/Edit.vue"
import Info from "./views/Info.vue"
import Live from "./views/Live.vue"
import Registry from "./views/Registry";
import Faq from "./views/Faq";

Vue.use(Router);

let router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "",
      component: Menu,
    },
    {
      path: "/rsvp",
      name: "RSVP",
      component: RSVP,
    },
    {
      path: "/edit",
      name: "Edit",
      component: Edit,
    },
    {
      path: "/info",
      name: "Info",
      component: Info,
    },
    {
      path: "/live",
      name: "Live",
      component: Live,
    },
    {
      path: "/registry",
      name: "Registry",
      component: Registry,
    },
    {
      path: "/spider/1",
      name: "Spider1Suit",
      component: Spider,
      props: {
        gameMode: "1"
      }
    },
    {
      path: "/spider/2",
      name: "Spider4Suit",
      component: Spider,
      props: {
        gameMode: "2"
      }
    },
    {
      path: "/games",
      name: "Games",
      component: Games,
    },
    {
      path: "/mines",
      name: "Mines",
      component: Mines,
    },
    {
      path: "/klondike",
      name: "Klondike",
      component: Klondike
    },
    {
      path: "/faq",
      name: "FAQ",
      component: Faq
    },
    {
      path: "*",
      redirect: "/"
    }
  ]
});

export default router;
